
import React, { useState } from 'react';
import { VideoCameraOutlined } from '@ant-design/icons';
import { Tooltip, Radio } from 'antd';
import Spinner from '../../../Spinner';
import moment from 'moment';
import { isEmpty } from 'underscore';
import { Link } from 'react-router-dom';
import { saveAs } from 'file-saver';
import GoogleStreetIcon from '../../../../assets/images/street-view-icon.png';
import RoadWithClock from '../../../../assets/images/road-with-clock.png';
import Icon from '../../../elements/Icon';
import { fetchApiAuth, getAddressFromLatLong } from '../../../../core/utils/api';
import { Video, Time, Notification, Report, Download } from '@carbon/icons-react';
import { triggerErrorNotification, triggerSuccessNotification } from '../../../../core/utils/notificationUtils';
import PropTypes from 'prop-types';

import './mapAssetPopup.scss';
import { UnitOfDistance, UnitOfSpeed } from '../../../../types/types';

const { DB_DATETIME_FORMAT, DB_DATE_FORMAT, SPEEDING_ALERT_EVENT_TYPE } = require('../../../../core/constants').default;
let activeLat = null;
let activeLng = null;
let activeLocation = '';

function MapAssetPopupHead(props) {
    const [isExportingTimesheetCsv, setIsExportingTimesheetCsv] = useState(false);
    const assetId = props.assetId ? props.assetId : null;
    const selectedDate = props.selectedDate ? props.selectedDate : null;
    const registration = props.registration ? props.registration : null;
    const deviceDetailedLocationInfo = props.deviceDetailedLocationInfo ? props.deviceDetailedLocationInfo : null;

    let driverScore = '-';
    if (deviceDetailedLocationInfo && deviceDetailedLocationInfo.driver_score) {
        driverScore = deviceDetailedLocationInfo.driver_score;
        driverScore = Number(driverScore).toFixed(0);
    }

    const handleHistoricVideosClick = () => {
        if (props.onUpdateVideoSearch) {
            const date = moment(selectedDate, 'YYYYMMDD').format(DB_DATE_FORMAT);
            props.onUpdateVideoSearch({
                asset_id: assetId,
                date,
            });
        }
    };

    const exportRecordsCsv = () => {
        if (props.isExportingCsv) {
            return;
        }

        if (assetId) {
            const date = moment(selectedDate, 'YYYYMMDD').format(DB_DATE_FORMAT);
            props.onGetCsvAssetRecordsByDayRequest({
                assetId,
                date,
            });
        }
        return true;
    };

    const exportTimesheetCsv = async () => {
        if (isExportingTimesheetCsv || !assetId) {
            return;
        }
        if (assetId) {
            setIsExportingTimesheetCsv(true);
            const date = moment(selectedDate, 'YYYYMMDD').format(DB_DATE_FORMAT);
            let params = {
                date_from: date,
                date_to: date,
                asset_or_driver: "assets",
                asset_id: [assetId],
                journey_or_day: "journeys",
            }

            const opts = {
                method: 'GET',
                url: `/report/get-timesheet-report-csv`,
                params,
            };

            const response = await fetchApiAuth(opts)
                .catch((err) => {
                    const message = err?.response?.data?.message ?? 'Failed to create timesheet csv.';
                    triggerErrorNotification(message);
                    return null;
                });
            if (response?.data) {
                const blob = new Blob([response.data], { type: 'application/csv' });
                saveAs(blob, 'Timesheet.csv');
                triggerSuccessNotification('File downloaded successfully.');
            }
            setIsExportingTimesheetCsv(false);
        }
        return true;
    }

    const showLiveVideoBtn = props.user && props.user.permissions.historic_video_downloading === true && props.dvrImei;
    const showHistoricVideoBtn = props.user && props.user.permissions.live_video === true && props.assetId && props.dvrImei;

    return (
        <>
            <div className="map-popup__head">

                <div className="d-flex align-center">
                    <h5 className="h-5">{props.heading || '[not-set]'}</h5>
                    &nbsp;
                    {props.devices && (props.devices).find((device) => device == '0')
                        ? <Icon name="speedometer" /> : null}
                    {props.devices && (props.devices).find((device) => device == '1') ? <Icon name="video" /> : null}
                </div>
                <p className="map-popup__subtitle">
                    {props.showQuickActionButtons && deviceDetailedLocationInfo && (
                        <>

                        </>
                    )}
                </p>
                {props.showQuickActionButtons && (
                    <div style={{ position: 'absolute', top: '32px', right: '32px' }}>
                        <Radio.Group value="large">
                            <Tooltip
                                placement="topLeft"
                                title={showLiveVideoBtn ? "Live Video Feed" : "Asset does not have a DVR device"}
                            >
                                <Radio.Button
                                    value="default"
                                    disabled={!showLiveVideoBtn}
                                >
                                    <Link
                                        to={`/video/live-videos/${props.assetId}`}
                                        onClick={(e) => {
                                            if (!showLiveVideoBtn) {
                                                e?.preventDefault();
                                            }
                                        }}
                                        style={{
                                            verticalAlign: 'middle',
                                            pointerEvents: showLiveVideoBtn ? 'all' : 'none',
                                        }}
                                    >
                                        <Video />
                                    </Link>
                                </Radio.Button>
                            </Tooltip>
                            <Tooltip
                                placement="topLeft"
                                title={showHistoricVideoBtn ? "Historic Videos" : "Asset does not have a DVR device"}
                            >
                                <Radio.Button
                                    value="default"
                                    disabled={!showHistoricVideoBtn}
                                >
                                    <Link
                                        to="/video/video-search"
                                        onClick={(e) => {
                                            if (!showHistoricVideoBtn) {
                                                e?.preventDefault();
                                            } else {
                                                handleHistoricVideosClick();
                                            }
                                        }}
                                        style={{
                                            verticalAlign: 'middle',
                                            pointerEvents: showHistoricVideoBtn ? 'all' : 'none',
                                        }}
                                    >
                                        <Time />
                                    </Link>
                                </Radio.Button>
                            </Tooltip>
                            {selectedDate && props.user && props.user.permissions.event_searching === true && (
                                <>
                                    {deviceDetailedLocationInfo.act_as_tracker ? (
                                        <Tooltip
                                            placement="topLeft"
                                            title={(
                                                <>
                                                    Event History not available for this Asset -
                                                    &ensp;
                                                    <a
                                                        href="https://www.fleetclear.com/contact"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Click Here
                                                    </a>
                                                    &ensp;
                                                    to find out more
                                                </>
                                            )}
                                        >
                                            <Radio.Button
                                                value="default"
                                                style={{ fontFamily: 'inherit' }}
                                                disabled
                                            >
                                                <Link
                                                    to="#"
                                                    style={{
                                                        verticalAlign: 'middle',
                                                        fontFamily: 'inherit',
                                                    }}
                                                >
                                                    <Notification />
                                                </Link>
                                            </Radio.Button>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip
                                            placement="topLeft"
                                            title="Event History"
                                        >
                                            <Radio.Button value="default">
                                                <Link
                                                    to="/events/search"
                                                    onClick={() => {
                                                        props.onEventSearch({
                                                            assetId,
                                                            dateFrom: selectedDate,
                                                        });
                                                    }}
                                                    style={{
                                                        verticalAlign: 'middle',
                                                    }}
                                                >
                                                    <Notification />
                                                </Link>
                                            </Radio.Button>
                                        </Tooltip>
                                    )}
                                </>
                            )}
                            {deviceDetailedLocationInfo.act_as_tracker ? (
                                <Tooltip
                                    placement="topLeft"
                                    title={(
                                        <>
                                            Timesheet Report not available for this Asset -
                                            &ensp;
                                            <a
                                                href="https://www.fleetclear.com/contact"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Click Here
                                            </a>
                                            &ensp;
                                            to find out more
                                        </>
                                    )}
                                >
                                    <Radio.Button value="default" style={{ fontFamily: 'inherit' }} disabled>
                                        <Link
                                            to="#"
                                            style={{
                                                verticalAlign: 'middle',
                                                fontFamily: 'inherit',
                                            }}
                                        >
                                            <Report />
                                        </Link>
                                    </Radio.Button>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    placement="topLeft"
                                    title="Timesheet Report"
                                >
                                    <Radio.Button
                                        value="default"
                                        disabled={isExportingTimesheetCsv}
                                    >
                                        <Link
                                            to="#"
                                            onClick={exportTimesheetCsv}
                                            style={{ verticalAlign: 'middle' }}
                                        >
                                            {isExportingTimesheetCsv ? (
                                                <Spinner
                                                    size={16}
                                                    minHeight={20}
                                                    loading={isExportingTimesheetCsv}
                                                >
                                                    <Report />
                                                </Spinner>
                                            ) : (
                                                <Report />
                                            )}
                                        </Link>
                                    </Radio.Button>
                                </Tooltip>
                            )}
                            {deviceDetailedLocationInfo.act_as_tracker ? (
                                <Tooltip
                                    placement="topLeft"
                                    title={(
                                        <>
                                            Download Records not available for this Asset -
                                            &ensp;
                                            <a
                                                href="https://www.fleetclear.com/contact"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Click Here
                                            </a>
                                            &ensp;
                                            to find out more
                                        </>
                                    )}
                                >
                                    <Radio.Button
                                        value="default"
                                        style={{ fontFamily: 'inherit' }}
                                        disabled
                                    >
                                        <Link
                                            to="#"
                                            style={{
                                                verticalAlign: 'middle',
                                                fontFamily: 'inherit',
                                            }}
                                        >
                                            <Download />
                                        </Link>
                                    </Radio.Button>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    placement="topLeft"
                                    title="Download Records"
                                >
                                    <Radio.Button
                                        value="default"
                                        disabled={props.isExportingCsv}
                                    >
                                        <Link
                                            to="#"
                                            onClick={exportRecordsCsv}
                                            style={{
                                                verticalAlign: 'middle',
                                            }}
                                        >
                                            {props.isExportingCsv ? (
                                                <Spinner
                                                    size={16}
                                                    minHeight={20}
                                                    loading={props.isExportingCsv}
                                                >
                                                    <Download />
                                                </Spinner>
                                            ) : (
                                                <Download />
                                            )}
                                        </Link>
                                    </Radio.Button>
                                </Tooltip>
                            )}
                        </Radio.Group>
                    </div>
                )}

                {props.hasEvents && props.priority === '1' && (
                    <button
                        type="button"
                        className="btn btn-empty">
                        <Icon name="youtube" />
                    </button>
                )}
            </div>
            {props.showQuickActionButtons && deviceDetailedLocationInfo && (
                <p style={{
                    padding: '0 16px 16px 16px',
                }}>
                    Driver Score: {driverScore}
                </p>
            )}
        </>
    );
}

function MapEventPopupHead(props) {
    return (
        <div className="map-popup__head">
            <div>
                <div className="d-flex align-center">
                    <h5 className="h-5">{props.heading || '[not-set]'}</h5>&nbsp;
                </div>
                <p className="map-popup__subtitle">
                    {props.registration || '[not-set]'}
                </p>

            </div>
        </div>
    );
}

function MapAssetPopupContent(props) {
    if (props.showNoData) {
        return (
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100px', minWidth: '650px',
            }}>
                <p style={{ color: 'var(--cool-gray-80)' }}>No record data available</p>
            </div>
        );
    }
    const { speed } = props;
    const loading = (props.showLoading && props.showLoading === true) || false;

    // this will eliminate the call every time component been rerendered, only it will call if the lat and lng been updated
    if ((props.lat != null && props.lng != null) && (activeLat !== props.lat || activeLng !== props.lng)) {
        activeLat = props.lat;
        activeLng = props.lng;
        activeLocation = getAddressFromLatLong(props.lat, props.lng);
    }

    let trip_odometer = null;
    const odometerData = props.location_data ? props.location_data.filter((ld) => ld.description === 'Odometer')[0] : null;
    if (odometerData) {
        trip_odometer = parseFloat(odometerData.value);
        if (props.speedUnit && props.speedUnit === UnitOfSpeed.BritishImperial) {
            // trip_odometer is in metres, convert it to Miles
            trip_odometer = parseFloat(trip_odometer / 1000);
            trip_odometer = parseFloat(trip_odometer / 1.609344);
            if (trip_odometer > 999999) {
                trip_odometer = trip_odometer.toFixed(0);
            } else {
                trip_odometer = trip_odometer.toFixed(2);
            }
        } else {
            // trip_odometer is in metres, convert it to Km
            trip_odometer = parseFloat(trip_odometer / 1000);
            if (trip_odometer > 999999) {
                trip_odometer = trip_odometer.toFixed(0);
            } else {
                trip_odometer = trip_odometer.toFixed(2);
            }
        }
    }

    let distanceUnit = '';
    if (props?.speedUnit) {
        switch (props.speedUnit) {
            case UnitOfSpeed.BritishImperial:
                distanceUnit = UnitOfDistance.BritishImperial;
                break;
            case UnitOfSpeed.Metric:
                distanceUnit = UnitOfDistance.Metric;
                break;
            default:
                distanceUnit = '';
                break;
        }
    }

    return (
        <Spinner
            loading={loading}
            minHeight={128}
            size={32}
        >
            <div style={{
                display: 'flex',
                minHeight: '250px',
                minWidth: '650px',
            }}>
                <div className="map-popup__body">
                    <div className="map-popup__datalist">
                        {
                            props.showPicture ? (
                                <div className="map-popup__picture">
                                    <div style={{
                                        width: 100,
                                        height: 100,
                                        backgroundImage: `url("${props.assetPicture || props.defaultImage}")`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }} />
                                    {props.userPicture && (
                                        <div style={{
                                            width: 100,
                                            height: 100,
                                            backgroundImage: `url("${props.userPicture}")`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            marginLeft: 5,
                                        }} />
                                    )}
                                </div>
                            )
                                : null
                        }
                        <p>{props.driver || ''}</p>
                        <p style={{
                            whiteSpace: 'pre-line',
                            width: 200,
                        }}>
                            {`${activeLocation || ''}`}
                        </p>
                        <p>{props.lat && props.lng ? `(${props.lat}, ${props.lng})` : ''}</p>
                        {props.dateTime != null
                            ? <p>Time: {moment(props.dateTime, DB_DATETIME_FORMAT).format('DD/MM/YYYY HH:mm:ss')}</p>
                            : null}
                        {props.event_key != null
                            ? <p style={{ color: 'rgb(255, 135, 51)', fontWeight: 'bold' }}>Event: {props.event_key}</p>
                            : null}
                        <p>
                            {props.online_status !== undefined ? (
                                props.online_status ? `Currently ${props.online_status}` : 'Currently Offline'
                            ) : null}
                        </p>
                    </div>

                    <div className="map-popup-icons">
                        {props.isFetching ? (
                            <div>Fetching speed...</div>
                        ) : (
                            <>
                                {
                                    speed != null ? (
                                        <div className="map-popup-icon">
                                            <span className="map-popup__speedometer" style={{ fontSize: parseInt(speed) > 99 ? '10px' : '12px' }}>{speed}</span>
                                            <span className="ml-1">{props.event_type === SPEEDING_ALERT_EVENT_TYPE ? 'Max Speed' : 'Speed'} ({props.speedUnit || ''})</span>
                                        </div>
                                    ) : (
                                        <div className="map-popup-icon">
                                            <span>Speed not available</span>
                                        </div>
                                    )
                                }
                            </>
                        )}

                        <div
                            className="map-popup-icon"
                            style={{
                                float: 'right',
                                display: loading ? 'none' : 'block',
                                backgroundColor: '#fff',
                            }}
                            onClick={() => props.streetViewIconClicked(props.lat, props.lng, props.angle, props.googleMapAccessRef)}>
                            <Tooltip title="Show Asset's StreetView">
                                <span className="map-popup__streetview">
                                    <img src={GoogleStreetIcon} />
                                </span>
                            </Tooltip>
                        </div>
                        {props.showTimeToDestinationBtn && props.lat && props.lng ? (
                            <div
                                className="map-popup-icon"
                                style={{
                                    float: 'right',
                                    display: loading ? 'none' : 'block',
                                    marginRight: '15px',
                                }}>
                                <Tooltip title="Calculate Time to Destination">
                                    <a
                                        href={`https://www.google.com/maps/dir/?api=1&origin=${parseFloat(props.lat)},${parseFloat(props.lng)}`}
                                        target="_blank"
                                        rel="noreferrer">
                                        <span className="map-popup__streetview">
                                            <img src={RoadWithClock} />
                                        </span>
                                    </a>
                                </Tooltip>
                            </div>
                        ) : null}
                        {props && props.videoFunc ? (
                            <div
                                className="map-popup-icon"
                                style={{
                                    float: 'right',
                                    display: loading ? 'none' : 'block',
                                    fontSize: '23px',
                                    color: '#666',
                                    marginRight: '15px',
                                }}
                                onClick={props.videoFunc}>
                                <Tooltip title="Video Cameras">
                                    <span className="map-popup__camera">
                                        <VideoCameraOutlined />
                                    </span>
                                </Tooltip>
                            </div>
                        ) : null}
                    </div>
                </div>

                {!isEmpty(props.location_data) && Array.isArray(props.location_data)
                    ? (
                        <div className="map-popup__datatable">
                            <table>
                                <tbody>
                                    {props.location_data && props.location_data.map((element) => (
                                        <tr key={element.value}>
                                            <td>{element.description}</td>
                                            <td>{element.description === 'Odometer'
                                                ? `${trip_odometer} ${distanceUnit}`
                                                : element.value}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : null}
            </div>
        </Spinner>
    );
}
MapAssetPopupContent.propTypes = {
    event_type: PropTypes.number,
    speedUnit: PropTypes.string,
}

function MapEventPopupContent(props) {
    // this will eliminate the call every time component been rerendered, only it will call if the lat and lng been updated
    if (activeLat !== props.lat || activeLng !== props.lng) {
        activeLat = props.lat;
        activeLng = props.lng;
        activeLocation = getAddressFromLatLong(props.lat, props.lng);
    }

    return (
        <div className="map-popup__body">
            <div className="map-popup__datalist">
                {props.dateTime != null ? <p>Time: {moment(props.dateTime, DB_DATETIME_FORMAT).format('DD/MM/YYYY HH:mm:ss')}</p> : null}
                <p>{props.driver || '-'}</p>
                <p>{`${activeLocation} (${props.lat}, ${props.lng})`}</p>
                {props.event_key != null ? <p>Event: {props.event_key}</p> : null}
            </div>
            <div className="map-popup-icon">
                <span className="map-popup__speedometer">{props.speed}</span>
                <span className="ml-1">{props.event_type === SPEEDING_ALERT_EVENT_TYPE ? 'Max Speed' : 'Speed'} ({props.speedUnit || ''})</span>
            </div>
            <div className="map-popup-icon" style={{ float: 'right' }} onClick={() => props.streetViewIconClicked(props.lat, props.lng, props.angle, props.googleMapAccessRef)}>
                <span className="map-popup__streetview">
                    <img src={GoogleStreetIcon} />
                </span>
            </div>
            {props && props.videoFunc
                ? (
                    <div
                        className="map-popup-icon"
                        style={{
                            float: 'right', fontSize: '23px', color: '#666', marginTop: '15px', marginRight: '15px',
                        }}
                        onClick={props.videoFunc}>
                        <span className="map-popup__camera">
                            <VideoCameraOutlined />
                        </span>
                    </div>
                )
                : null}
        </div>
    );
}
MapEventPopupContent.propTypes = {
    event_type: PropTypes.number,
}

export default {
    MapAssetPopupHead,
    MapAssetPopupContent,
    MapEventPopupHead,
    MapEventPopupContent,
};
